import React from 'react'

const NotFound = () => {
    return (
        <h1>This page does not exist...</h1>
    )
}

export default NotFound
